<template>
  <div class="app-container" style="height: 100%;overflow-y: auto;padding: 0px;">
    <div class="contract-main" id="contract">
      <div class="contract-main-content">
        <div class="title1">
          房 屋 租 赁 合 同
        </div>
        <div class="row">
          甲方（ 出租方） 姓名:
          <el-input class="flex-1" v-model="contractDialog.formData.partyAName"></el-input>
          电 话:
          <el-input class="flex-1" v-model="contractDialog.formData.partyAPhone"></el-input>
        </div>
        <div class="row">
          身份证号码:
          <el-input class="flex-1" v-model="contractDialog.formData.partyACard"></el-input>
        </div>
        <div class="row">
          乙方（ 承租方） 姓名:
          <el-input class="flex-1" v-model="contractDialog.formData.partyBName"></el-input>
          电 话:
          <el-input class="flex-1" v-model="contractDialog.formData.partyBPhone"></el-input>
        </div>
        <div class="row">
          身份证号码:
          <el-input class="flex-1" v-model="contractDialog.formData.partyBCard"></el-input>
          工作单位:
          <el-input class="flex-1" v-model="contractDialog.formData.partyBWork"></el-input>
        </div>
        <div class="row">
          经甲、乙双方在自愿、平等互利的基础上友好协商达成如下协议：
        </div>
        <div class="row">
          一、甲方将
          <el-input v-model="contractDialog.formData.address" style="width: 260px;"></el-input>
          的房屋出租乙方只能居住，不得进行其它用途，乙方共住
          <el-input v-model="contractDialog.formData.personTotal" style="width: 60px;"></el-input>
          人。
        </div>
        <div class="row">
          二、每月租金为
          <el-input v-model="contractDialog.formData.rent" style="width: 70px;"></el-input>
          元人民币，一次性共收押金
          <el-input v-model="contractDialog.formData.deposit" style="width: 70px;"></el-input>
          元人民币，每次交房租必须按照约定交租时间，先交钱后入住，
        </div>
        <div class="row">
          乙方租期不满退租视为违约，扣除当月房租和押金 。
        </div>
        <div class="row">
          三、从
          <el-input v-model="contractDialog.formData.fromYear" style="width: 70px;"></el-input>
          年
          <el-input max="12" v-model="contractDialog.formData.fromMonth" style="width: 70px;"></el-input>
          月
          <el-input v-model="contractDialog.formData.fromDay" style="width: 70px;"></el-input>
          日起至
          <el-input v-model="contractDialog.formData.toYear" style="width: 70px;"></el-input>
          年
          <el-input style="width: 70px;" v-model="contractDialog.formData.toMonth"></el-input>
          月
          <el-input style="width: 70px;" v-model="contractDialog.formData.toDay"></el-input>
          日， 租期期满前乙方不需
        </div>
        <div class="row">
          续签合同的，需提前壹个月通知甲方，甲方未接到通知的情况下，本合同作自动续签，续签时长为之前租期如原租期小于三个月的视为三个月，其余内容不变，此合同继续生效 。任何时间押金不可 以抵房租或其它费用。
        </div>
        <div class="row">
          四、租金
          <el-input v-model="contractDialog.formData.payMonth" style="width: 50px;"></el-input>
          个月支付一次， 以后每月付款时间为
          <el-input v-model="contractDialog.formData.payDate" style="width: 70px;"></el-input>
          号支付给甲方， 押金不可抵房租，逾期不付视为
        </div>
        <div class="row">
          违约处理，没收押金，甲方有权终止合同，乙方无条件退房。
        </div>
        <div class="row">
          五、乙方责任及义务： 为了您能有个舒适的环境 ， 请您及时打扫室内外 ，保持室内外的清 洁卫生 、保持通风换气 ， 节约水电 ， 并提高安全用电防火防盗意识。
        </div>
        <div class="row">
          六、乙方在居住期间 ， 不得以任何理由退房 ，转租需获得甲方同意 ，一旦主动退房，不但视为违约，没收当月房租 、押金外，还要交完已产生的一切费用，并要交 出钥匙方能搬出 。故意带走甲方租住房内的钥匙 家电 家具等物品的为盗窃 ， 情节严重报予警方处理。
        </div>
        <div class="row">
          七、乙方不得在室内打闹 ，喧哗 ， 电视音响太大 ，不得影响他人和邻居休息 ，一但发现视为违约扣除押金以及当月房租，并且无条件退房。
        </div>
        <div class="row">
          八、 乙方在入住期间 ，房租拖欠叁天 ，甲方联系不上乙方 ，视为乙方自愿放弃 ，甲方有权终止合同。 其室内物品，视作无主处理。入住天数不满壹个月，按壹个月计算。
        </div>
        <div class="row">
          九、如有故意损坏房内物品的，一切物品照价赔偿，将扣除房租、押金，收回房屋。
        </div>
        <div class="row">
          十、乙方保证遵守国家的法律法规规定以及租赁房屋所在小区的物业管理规约。乙方在居住期间的人身安全和财产安全由乙方自行负责，在租赁期内乙方是该房屋的实际管理人，该房屋内发生的所有安全事故都由乙方来承担与甲方无关包括但不限于高空抛物，水电使用不当，在房间内摔倒，给乙方及同住人造成的人生伤害等，甲方都不承担任何责任。
        </div>
        <div class="row" style="display: -webkit-box;">
          十一、未经甲方允许，不得私自加人，加一人 多收房租壹佰 元/月，<span style="color: blue">未经房东批准不准养宠物，私养宠物按本合同第二条违约条款处理。</span>
        </div>
        <div class="row">
          十二、房间内物品如由人为损坏，按照物价赔偿，老旧自然损坏房东负责免费维修，如出现漏水（主要马桶），乙方没有及时通知甲方造成的损失由乙方承担，如由于乙方水电煤使用不当，导致出现火灾，漏水，漏电等情况出现意外，一切损失由乙方负责。乙方退租时如卫生没有打扫干净扣除200元押金。
        </div>
        <div class="row">
          十三、合同到期后，甲方如验房无误，会于10个工作日（自合同到期日起算）内退还乙方押金。乙方如需开具租房发票需签约前告知甲方。
        </div>
        <div class="row">
          十四、房屋配置: 床
          <el-input v-model="contractDialog.formData.furniture.bed" style="width: 50px;"></el-input>
          只,桌子
          <el-input v-model="contractDialog.formData.furniture.board" style="width: 50px;"></el-input>
          张,椅子
          <el-input v-model="contractDialog.formData.furniture.chair" style="width: 50px;"></el-input>
          把,沙发
          <el-input v-model="contractDialog.formData.furniture.sofa" style="width: 50px;"></el-input>
          只,衣柜
          <el-input v-model="contractDialog.formData.furniture.wardrobe" style="width: 50px;"></el-input>
          个,冰箱
          <el-input v-model="contractDialog.formData.furniture.refrigerator" style="width: 50px;"></el-input>
          个,洗衣机
          <el-input v-model="contractDialog.formData.furniture.washingMachine" style="width: 50px;"></el-input>
          个,油烟机
          <el-input v-model="contractDialog.formData.furniture.hood" style="width: 50px;"></el-input>
          个,电磁炉
          <el-input v-model="contractDialog.formData.furniture.microwaveOven" style="width: 50px;"></el-input>
          个,燃气灶
          <el-input v-model="contractDialog.formData.furniture.gasCooker" style="width: 50px;"></el-input>
          个,热水器
          <el-input v-model="contractDialog.formData.furniture.heater" style="width: 50px;"></el-input>
          个,空调
          <el-input v-model="contractDialog.formData.furniture.airConditioning" style="width: 50px;"></el-input>
          台, 钥匙
          <el-input v-model="contractDialog.formData.furniture.key" style="width: 50px;"></el-input>
          把
        </div>
        <div class="row">
          备注：
          <el-input style="width: 100%;" v-model="contractDialog.formData.remark"></el-input>
        </div>
        <div class="row">
          十五、此合约为电子合约，以上协议内容甲乙双方一致同意，乙方在签字前已经对以上条约和约定仔细阅读并认可，签字生效，请妥善保存好自己的合同。
        </div>
        <div style="display: flex;justify-content: space-between;">
          <div class="row" style="display: flex;justify-content: space-between;" v-if="!contractDialog.formData.partyASignName || contractDialog.formData.partyASignName.indexOf('https://www.woyaozu.com.cn/group1') == -1">
            <div>
              甲方签名:
              <el-input v-model="contractDialog.formData.partyASignName"></el-input>
            </div>
          </div>
          <div class="row" v-if="contractDialog.formData.partyASignName && contractDialog.formData.partyASignName.indexOf('https://www.woyaozu.com.cn/group1') != -1">
            甲方签名:
          </div>
          <div class="row" style="display: flex;justify-content: center;align-items: center;" v-if="contractDialog.formData.partyASignName && contractDialog.formData.partyASignName.indexOf('https://www.woyaozu.com.cn/group1') != -1">
            <div v-if="contractDialog.formData.partyASignName">
              <img :src="contractDialog.formData.partyASignName" style="width: 35%;height: 35%;"/>
            </div>
          </div>
          <div class="row">
            乙方签名:
          </div>
          <div class="row" style="display: flex;justify-content: center;align-items: center;">
            <div v-if="contractDialog.formData.partyBSignName">
              <img :src="contractDialog.formData.partyBSignName" style="width: 35%;height: 35%;"/>
            </div>
          </div>
        </div>
        <div class="row" style="display: flex;justify-content: flex-end;">
          <div>
            签约日期：
            <el-input style="width: 70px;" v-model="contractDialog.formData.signYear"></el-input>
            年
            <el-input style="width: 70px;" v-model="contractDialog.formData.signMonth"></el-input>
            月
            <el-input style="width: 70px;" v-model="contractDialog.formData.signDay"></el-input>
            日
          </div>
        </div>
      </div>
    </div>
    <div style="position: fixed;top: 10px;right: 1%;" v-if="showSave">
      <el-button icon="el-icon-upload" circle type="primary" @click="createImg" :loading="contractLoading"
                 v-if="contractDialog.formData.signed">
      </el-button>
    </div>
  </div>
</template>
<script>

import {getInfo, saveOrUpdateData as saveOrUpdateContract} from "@/api/rentContract";
import {getById} from "@/api/rentRecord";
import {uploadFile} from "@/api/fileUtil";
import html2canvas from 'html2canvas';
import JSPDF from 'jspdf';

export default {
  data() {
    return {
      loading: false,
      payTypes: [
        {
          id: 0,
          name: '月付'
        },
        {
          id: 4,
          name: '两月付'
        },
        {
          id: 1,
          name: '季付'
        },
        {
          id: 2,
          name: '半年付'
        },
        {
          id: 3,
          name: '年付'
        }
      ],
      states: [
        {
          id: 0,
          name: '出租中'
        },
        {
          id: 4,
          name: '未生效'
        }
      ],
      oldPayType: 0,
      contractDialog: {
        formData: {
          code: '',
          rentRecordId: '',
          partyAName: '',
          partyAPhone: '',
          partyACard: '',
          partyBName: '',
          partyBPhone: '',
          partyBCard: '',
          partyBWork: '',
          address: '',
          personTotal: '',
          rent: '',
          deposit: '',
          startDate: '',
          endDate: '',
          payMonth: '',
          payDate: '',
          roomId: '',
          roomName: '',
          adminId: '',
          adminName: '',
          furniture: {
            bed: '',
            board: '',
            chair: '',
            sofa: '',
            teaTable: '',
            wardrobe: '',
            television: '',
            setTopBox: '',
            tvCabinet: '',
            refrigerator: '',
            washingMachine: '',
            microwaveOven: '',
            heater: '',
            gasCooker: '',
            hood: '',
            airConditioning: '',
            electricityMeterReading: '',
            waterMterReading: '',
            key: ''
          },
          remark: '',
          contractUrl: '',
          partyASignName: '',
          partyBSignName: '',
          fromYear: '',
          fromMonth: '',
          fromDay: '',
          toYear: '',
          toMonth: '',
          toDay: '',
          signYear: '',
          signMonth: '',
          signDay: '',
          stayPlace: '',
          generate: false,
          signed: false
        },
        visible: false
      },
      rentRecordDialog: {
        formData: {}
      },
      contractLoading: false,
      admins: [],
      imageDialog: {
        imageUrl: '',
        visible: false
      },
      userInfo: {},
      fileList: [],
      id: '',
      showSave: false
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.openContractDialog()
  },
  methods: {
    // 根据不同的年月日拼装日期格式
    dealDateFormat(year, month, day) {
      return `${year}-${month}-${day}`
    },
    saveContract(generate) {
      const that = this
      that.contractDialog.formData.generate = generate
      const furniture = this.contractDialog.formData.furniture
      if (furniture) {
        that.contractDialog.formData.furniture = JSON.stringify(furniture)
      }
      that.contractDialog.formData.rentRecordId = that.rentRecordDialog.formData.id
      that.contractDialog.formData.roomId = that.rentRecordDialog.formData.roomId
      that.contractDialog.formData.roomName = that.rentRecordDialog.formData.roomName
      that.contractDialog.formData.adminId = that.rentRecordDialog.formData.adminId
      that.contractDialog.formData.adminName = that.rentRecordDialog.formData.adminName
      // 拼接日期
      if (that.contractDialog.formData.fromYear && that.contractDialog.formData.fromMonth && that.contractDialog.formData.fromDay) {
        that.contractDialog.formData.startDate = that.dealDateFormat(that.contractDialog.formData.fromYear, that.contractDialog.formData.fromMonth, that.contractDialog.formData.fromDay)
      }
      if (that.contractDialog.formData.toYear && that.contractDialog.formData.toMonth && that.contractDialog.formData.toDay) {
        that.contractDialog.formData.endDate = that.dealDateFormat(that.contractDialog.formData.toYear, that.contractDialog.formData.toMonth, that.contractDialog.formData.toDay)
      }
      if (that.contractDialog.formData.signYear && that.contractDialog.formData.signMonth && that.contractDialog.formData.signDay) {
        that.contractDialog.formData.signDate = that.dealDateFormat(that.contractDialog.formData.signYear, that.contractDialog.formData.signMonth, that.contractDialog.formData.signDay)
      }
      // 拼装url
      saveOrUpdateContract(that.contractDialog.formData).then(response => {
        if (response.code == 200) {
          // 操作成功
          that.contractLoading = false
          that.contractDialog.visible = false
        }
        that.contractLoading = false
      })
    },
    downloadContract() {
      window.open(this.contractDialog.formData.contractUrl)
    },
    openContractDialog() {
      const that = this
      getInfo(that.id).then(response => {
        that.contractDialog.formData = response.data
        const furniture = response.data.furniture || "{}"
        if (furniture) {
          that.contractDialog.formData.furniture = JSON.parse(furniture || "{}")
          if (that.contractDialog.formData.furniture.bed == undefined) {
            that.contractDialog.formData.furniture = JSON.parse(JSON.parse(furniture || "{}"))
          }
        }
        // 处理时间
        const startDate = this.contractDialog.formData.startDate
        if (startDate) {
          const dates = startDate.split('-');
          that.contractDialog.formData.fromYear = parseInt(dates[0])
          that.contractDialog.formData.fromMonth = parseInt(dates[1])
          that.contractDialog.formData.fromDay = parseInt(dates[2])
        } else {
          that.$set(that.contractDialog.formData, 'fromYear', '')
          that.$set(that.contractDialog.formData, 'fromMonth', '')
          that.$set(that.contractDialog.formData, 'fromDay', '')
        }
        const endDate = that.contractDialog.formData.endDate
        if (endDate) {
          const dates = endDate.split('-');
          that.contractDialog.formData.toYear = parseInt(dates[0])
          that.contractDialog.formData.toMonth = parseInt(dates[1])
          that.contractDialog.formData.toDay = parseInt(dates[2])
        } else {
          that.$set(that.contractDialog.formData, 'toYear', '')
          that.$set(that.contractDialog.formData, 'toMonth', '')
          that.$set(that.contractDialog.formData, 'toDay', '')
        }
        const signDate = that.contractDialog.formData.signDate
        if (signDate) {
          const dates = signDate.split('-');
          that.contractDialog.formData.signYear = parseInt(dates[0])
          that.contractDialog.formData.signMonth = parseInt(dates[1])
          that.contractDialog.formData.signDay = parseInt(dates[2])
        } else {
          that.$set(that.contractDialog.formData, 'signYear', '')
          that.$set(that.contractDialog.formData, 'signMonth', '')
          that.$set(that.contractDialog.formData, 'signDay', '')
        }
        that.contractDialog.visible = true
        getById(that.contractDialog.formData.rentRecordId).then(res => {
          that.rentRecordDialog.formData = res.data
          that.showSave = true
          that.createImg();
        })
      })
    },
    createImg() {
      let _this = this
      //解决页面带滚动条的时候截图不全问题
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      let canvas = document.createElement('canvas')
      let context = canvas.getContext('2d')
      //需要转换的html元素
      let _articleHtml = document.getElementById('contract')
      let _w = _articleHtml.clientWidth
      let _h = _articleHtml.clientHeight
      //解决生成的pdf不清晰的问题 先放大4倍----后面再缩小4倍
      let scale = 2
      canvas.width = _w * scale
      canvas.height = _h * scale
      context.scale(scale, scale)
      let opts = {
        scale: 1,
        width: _w,
        height: _h,
        canvas: canvas,
        useCORS: true
      };
      (window.html2canvas || html2canvas)(_articleHtml, opts).then(canvas => {
        _this.createPdf(canvas, scale)
      })
    },
    createPdf(canvas, scale) {
      //图片->pdf
      //-----------宽高缩小4倍---------------------
      let contentWidth = canvas.width / scale
      let contentHeight = canvas.height / scale
      //--------------------
      let orientation = 'p'
      // 在 jspdf 源码里，如果是 orientation = 'p' 且 width > height 时， 会把 width 和height 值交换，
      // 类似于 把 orientation 的值修改为 'l' , 反之亦同。
      if (contentWidth > contentHeight) {
        orientation = 'l'
      }

      let pdf = new JSPDF(orientation, 'pt', [contentWidth, contentHeight])
      let pageData = canvas.toDataURL('image/jpeg', 1.0)

      //这里只生成了一页的pdf，并未截断，需要截断的话在此处操作
      pdf.addImage(pageData, 'JPEG', 0, 0, contentWidth, contentHeight)

      //将pdf的流文件---》file文件
      let filename = this.contractDialog.formData.partyBName + '_' + this.contractDialog.formData.address + '.pdf'
      let datauri = pdf.output('dataurlstring')
      let file = this.dataURLtoFile(datauri, filename)

      this.uploadPDF(file)
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      //转换成file对象
      return new File([u8arr], filename, { type: mime })
      //转换成成blob对象
      //return new Blob([u8arr],{type:mime});
    },
    uploadPDF(file){
      const that = this
      that.contractLoading = true
      // 以文件的形式上传给服务器
      const formData = new FormData()
      formData.append('file', file)
      uploadFile(formData).then(response => {
        that.contractDialog.formData.contractUrl = response.path
        that.saveContract(true)
        that.$notify({
          title: '成功',
          message: '生成成功，请返回首页下载!',
          type: 'success'
        });
      })
    }
  }
}
</script>

<style scoped lang="scss">
.contract-main {
  margin: 0 auto;
  //width: 770px;
  padding: 15px;
  .flex-1 {
    flex: 1;
  }

  &-content {
    text-align: left;
    width: 100%;
    /deep/ .el-input {
      width: 150px;

      input {
        border: none;
        border-bottom: 1px solid #DCDFE6;
        border-radius: 0;
        height: 25px !important;
        line-height: 20px !important;
        font-weight: bolder;
        color: blue;
      }
    }

    .title1 {
      text-align: center;
      font-size: 20px;
      width: 100%;
    }

    .no {
      text-align: right;
      font-size: 18px;
      width: 100%;

      .noTxt {
        font-weight: bold;
      }

      .noNumber {
        color: red;
      }
    }

    .row {
      width: 100%;
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-bottom: 10px;
      line-height: 2;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/back/rentContract.vue